import React from 'react';
import { makeStyles } from '@material-ui/core';
import { object, func, bool, string } from 'prop-types';
import styles from '../../../../Application/AppDetails/Overview/EntityCard/styles';
import { getI18nFormattedMessage } from '../../../../../utils/intl';
import clsx from 'clsx';


export default function EntityCard({ entity, setActiveTab, apiGroupUuid }) {
  const useStyles = makeStyles(styles);
  const classes = useStyles();

const disabled = !apiGroupUuid;

  const entityTitles = {
    APIs: 'apis',
    Applications: 'applications',
  };

  const entityClickTab = {
    APIs: 'add-api-group-apis-tab',
    Applications: 'add-api-group-applications-tab',
  };
  
  const handleCardClick = (event, entityId) => {
    if(!disabled) {
      setActiveTab(entityClickTab[entityId]);
    }
  };


  const handleEnterKey = (event, entityId) => {
    const code = event.keyCode || event.which;
    if (code === 13) {
      handleCardClick(event, entityId);
    }
  };

  const getClassName = () => {
    if(entity.count < entity.errorCount) {
      return classes.errorCount;
    }
    if(entity.count < entity.warningCount) {
      return classes.warningCount;
    }
    return classes.normalCount;
  };
  
  const renderTile = () => (
    <div
      tabIndex="0"
      className={disabled ? classes.disabledCard : classes.card}
      onClick={e => handleCardClick(e, entity.entity)}
      onKeyDown={e => handleEnterKey(e, entity.entity, true)}
    >  <div className={disabled ? classes.disabledEntityTitle : classes.entityTitle}>
          {getI18nFormattedMessage(`label.application.details.overview.scrollbar.${entityTitles[entity.entity]}.title`)}
        </div>
        <div className={clsx(classes.entityCount, getClassName())}>{entity.count ? entity.count : "0"}</div>
    </div>
  );
  return (
    <>
      {
        renderTile()
      }
    </>
  );
}

EntityCard.propTypes = {
  entity: object,
  setActiveTab: func,
  disabled: bool,
  apiGroupUuid: string,
};
